<template>
  <div class="page-dev-playlist">
    <div class="page-container">
      <PlaylistPreview />
      <TwoPlayersPreview />
    </div>
  </div>
</template>

<script>
import PlaylistPreview from '../playlist/playlist-preview.vue';
import TwoPlayersPreview from '../playlist/two-players-preview.vue';

let bgColor = '';

export default {
  name: 'page-dev-playlist',
  components: {
    PlaylistPreview,
    TwoPlayersPreview,
  },
  mounted () {
    bgColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#b10202';
  },
  beforeDestroy () {
    document.body.style.backgroundColor = bgColor;
  },
};
</script>

<style scoped lang="scss">
.page-container {
  margin: 10px;
}
</style>
